import api from "@/apiConfig/api";

export const deleteTgBot = async (external_id) => {
  return await api.post("/me/student_telegram_remove", {
    external_id,
  });
};
export const groupCredentials = async (external_id) => {
  return await api({
    url: `/groups/${external_id}/group_space_credentials`,
    method: "post",
    responseType: "blob",
    data: {
      external_id,
    },
  });
};
export const studentPermission = async (external_id) => {
  return await api({
    url: "/me/give_student_permission",
    method: "post",
    responseType: "blob",
    data: {
      external_id,
    },
  });
};
export const getAdminAbout = () => {
  return api.get("/me");
};

export const updateGroup = async (external_id) => {
  return api.get(`/groups/${external_id}/update`, {
    external_id: external_id,
  });
};

export const getStudentsReport = async (lang = "uz", modme_id) => {
  return await api.get("/groups/students_report", {
    params: {
      lang: lang,
      external_id: modme_id,
    },
  });
};
export const getGroups = async (branch_id) => {
  return await api.get(`/groups/branch/${branch_id}`, {
    params: {
      actives: true,
      branch_id: branch_id,
    },
  });
};
export const getAdminInfo = () => {
  return api.get("/me");
};

export const getReports = () => {
  return api.get("/reports/admin/retention_reports");
};

export const postGroupRetentions = (retentionObj) => {
  return api.post("/reports/admin/retention_reports", retentionObj);
};
export const getAllHolidays = async (branch_id) => {
  return await api.get("/attendance/branch/holidays", {
    params: {
      company_id: branch_id,
    },
  });
};
export const setCompanyHoliday = async (
  branch_id,
  for_date,
  title,
  description
) => {
  return await api.post("/attendance/branch/holidays", {
    branch_id: branch_id,
    for_date: for_date,
    title: title,
    description: description,
  });
};

export const getSertificates = async (external_id) => {
  return await api.get(`/groups/${external_id}/students_certificate`);
};
